import Text from 'components/_UI/Text'
import React from 'react'
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import GeneralTransactions from './GeneralTransactions';
import styled from 'styled-components';
import { Row } from 'styled/alignment/Row';
import GeneralWithdraws from './GeneralWithdraws';
import { ChevronRight, Activity, ArrowDownCircle } from 'react-feather';
import breakpoints from 'theme/breakpoints';

export default function GeneralView({ statementBalance, withdraw, onStatementBalanceSeeAllClick, onSeeAllWithdrawClick }) {
    return (
        <Container>
            <CardContainer>
                <TitleHeader>
                    <SectionHeader>
                        <SectionIcon>
                            <Activity size={18} color={colors.occasionalPurple} />
                        </SectionIcon>
                        <HeaderContent>
                            <Text type='bold' color={colors.nightDark} paddingBottom={0}>
                                Transações recentes
                            </Text>
                            <Text name='small' color={colors.night} paddingBottom={0}>
                                Últimas movimentações financeiras
                            </Text>
                        </HeaderContent>
                    </SectionHeader>

                    {statementBalance?.length > 0 && (
                        <SeeAll onClick={onStatementBalanceSeeAllClick}>
                            <span>Ver todas</span>
                            <ChevronRight size={16} />
                        </SeeAll>
                    )}
                </TitleHeader>

                <GeneralTransactions data={statementBalance} />
            </CardContainer>

            <CardContainer>
                <TitleHeader>
                    <SectionHeader>
                        <SectionIcon>
                            <ArrowDownCircle size={18} color={colors.occasionalPurple} />
                        </SectionIcon>
                        <HeaderContent>
                            <Text type='bold' color={colors.nightDark} paddingBottom={0}>
                                Saques recentes
                            </Text>
                            <Text name='small' color={colors.night} paddingBottom={0}>
                                Últimos saques realizados
                            </Text>
                        </HeaderContent>
                    </SectionHeader>
                    {withdraw?.length > 0 && (
                        <SeeAll onClick={onSeeAllWithdrawClick}>
                            <span>Ver todas</span>
                            <ChevronRight size={16} />
                        </SeeAll>
                    )}
                </TitleHeader>

                <GeneralWithdraws withdraw={withdraw} />
            </CardContainer>
        </Container>
    )
}


const Container = styled(Column)`
    margin-top: 24px;
    gap: 16px;

    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
    }
`;

const CardContainer = styled(Column)`
    background: ${colors.neutralLight};
    border: 1px solid ${colors.neutralDark};
    padding: 20px;
    border-radius: 12px;
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: 0 2px 8px ${colors.night}0A;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        &:first-child {
            margin-right: 0;
        }
    }
`;

const SeeAll = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border: none;
    background: transparent;
    color: ${colors.secondaryPurple};
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover {
        background: #F3E8FF;
    }

    &:focus-visible {
        outline: 2px solid ${colors.occasionalPurple};
        outline-offset: 2px;
    }
`;

const TitleHeader = styled(Row)`
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid ${colors.neutralDark};
    margin-bottom: 4px;
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #F3EAFF;
    flex-shrink: 0;
`;

const HeaderContent = styled.div`
    flex: 1;
`;
